import { Checkbox } from 'antd';
import styled from 'styled-components';

export default styled(Checkbox)`
	// Add your styles here
`;
